const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/dashboard',
    userAuthenticatedEntryPath: '/task-dashboard',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '',
    enableMock: false
}

export default appConfig